import { GlAvatarLabeled, GlAvatarLink } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'ServiceAccountAvatar',
    components: {
        GlAvatarLabeled,
        GlAvatarLink
    },
    props: {
        serviceAccount: {
            type: Object,
            required: true
        }
    }
};
